<template>
  
  
    <v-container>
      <!-- Título -->
      <v-text class="display-1 ">Puntos de Venta</v-text>

      <!-- Grupo de Radio -->
      <v-row>
        <v-col>
          <v-radio-group v-model="localRadios" @change="emitirCambio">
            <template v-slot:label>
             <v-text class="subtitle-1 outline--text">
                Selecciona o crea un local/usuario punto de venta
              </v-text>
            </template>
             <!-- Opción Existente -->
             <v-radio value="existente">
              <template v-slot:label>
                <v-card-subtitle
                  >Seleccionar de la
                  <strong class="primary--text">Lista</strong></v-card-subtitle
                >
              </template>
            </v-radio>
            <!-- Opción Nuevo -->
            <v-radio value="nuevoLocal">
              <template v-slot:label>
                <v-card-subtitle>
                  Crear
                   nuevo <strong class="secondary--text">local</strong> punto de
                  venta
                </v-card-subtitle>
              </template>
            </v-radio>
             <!-- Opción Nuevo -->
             <v-radio value="nuevoUsuario">
              <template v-slot:label>
                <v-card-subtitle>
                  Crear
                   nuevo <strong class="tertiary--text">usuario</strong> de
                  venta
                </v-card-subtitle>
              </template>
            </v-radio>

           
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
 
</template>

<script>
import api from '@/api/configApi'
import {headers} from "@/api/headers";

  export default {
    props: {
      value: {
      type: String,
      default: '',
    },
  },
    data() {
      return {
        localRadios: this.value,
        menu: false,
        menu1: false,
        llistaPais: [{
                id: 1,
                descripcion: 'COLOMBIA'
            }],
            listaDepartamentos:[],
            listaCiudades:[],
            formData:{
                'pais':'COLOMBIA',
                'departamento_id':null,
                'ciudad':null,
                'direccion':null,
                'hora_almuerzo':null,
                'horario':null,
                'horario_atencion':null,
                'latitud':null,
                'longitud':null,
                'nombre':null,
                'status':null,
            },
            errors:[],
            id_evento: null
        };
    },
   
    async created(){
                    await verificarPermisos(this.$route.path);

        this.id_evento = this.$route.params.id

        api.get(`listardepartamentosxpais/1`,{headers:headers}).then((res)=>{
            this.listaDepartamentos = res.data.data
        }) 
    },
    mounted() {

    },
    watch:{
        'formData.departamento_id'(value, oldvalue){
            if(this.formData.departamento_id){
                api.get(`listarciudadesxdepartamento/${this.formData.departamento_id}`,{headers:headers}).then((res)=>{
                    this.listaCiudades = res.data.data
                })
            }
        },
        localRadios(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      // Si el valor del prop cambia, actualizamos localRadios
      this.localRadios = newVal;
    },
    },
    methods: {
      emitirCambio() {
      this.$emit('input', this.localRadios);
    },
        guardarRegistro(){
            new Swal({ title: "Espere un momento", allowOutsideClick: false, });
            Swal.showLoading();
            api.post('insertpuntoventamapa',this.formData,{headers:headers}).then((res)=>{
                
                Swal.fire("Guardado", res.data.message, "success").then(() => {
                    this.formData={
                        'pais':'COLOMBIA',
                        'departamento_id':null,
                        'ciudad':null,
                        'direccion':null,
                        'hora_almuerzo':null,
                        'horario':null,
                        'horario_atencion':null,
                        'latitud':null,
                        'longitud':null,
                        'nombre':null,
                        'status':null,
                    },
                    this.ischecked = false;
                    this.$router.push({
                        path: "/listarpuntoventafisico/"+this.$route.params.id
                    })
                });
            })
        },



    }
  };
</script>
<style scoped>
  .w-50 {
    width: 50%;
  }
</style>
